import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import LineChart from './LineChart'
import getFeaturesFromArray from '../utility/getFeaturesFromArray'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetSelectedData } from '../selectors/selectedDataSelector'
import { makeGetData } from '../selectors/dataSelector'
import ObjectActions from '../redux/objectRedux'
import MapActions from '../redux/mapRedux'
import TimeSliderActions from '../redux/timeSliderRedux'
import { RED, YELLOW, GREEN } from '../config/colors'

const chartStyles = {
  scatter: {
    data: {
      strokeWidth: 3,
      stroke: 'gray',
      strokeOpacity: 0.4,
      fill: d => (Math.abs(d.rank) >= 2 ? 'red' : Math.abs(d.rank) >= 1 ? 'orange' : 'white')
    }
  }
}

class WellsiteRankContainer extends PureComponent {
  handleClick = (event, data) => {
    const { actions } = this.props
    const uuids = data.data.map(datum => datum.uuid)
    // actions.uuidsHighlighted(uuids)
  }

  handleMouseEnter = (event, data) => {
    const { actions } = this.props
    const uuids = data.data.map(datum => datum.uuid)
    // actions.uuidsHighlighted(uuids)
  }

  handleMouseLeave = (event, data) => {
    const { actions } = this.props
    // actions.uuidsHighlighted([])
  }

  handleZoomToObject = (event, data) => {
    const { actions } = this.props
    const { latitude, longitude, timestamp } = data.datum
    const center = [longitude, latitude]
    const zoom = [15]
    // actions.centerZoomDatetimeChanged(center, zoom, timestamp)
  }

  render () {
    const { datetime, uuidsSelected, uuidsHighlighted, data } = this.props

    if (!data || data.constructor !== Array) {
      return null
    }

    const ids = [...new Set(data.map(datum => datum.wellsite_f))]
          
    const groupByFilters = ids.map(id => item =>
      item.wellsite_f === id
    )

    return (
      <Collapse component='div' in={!!data.length} unmountOnExit>
        <Typography>Standard deviation from control</Typography>
        <LineChart
          data={data}
          x={value => new Date(value.date)}
          y={value => value.rank}
          chartStyles={chartStyles}
          groupByFilters={groupByFilters}
          verticalLineAcessor={() => new Date(datetime).getTime()}
          datetime={new Date(datetime).getTime()}
          uuidsHighlighted={uuidsHighlighted}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          handleZoomToObject={this.handleZoomToObject}
          handleClick={this.handleClick}
        />
      </Collapse>
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getSelectedData = makeGetSelectedData()
  const getData = makeGetData()

  const mapStateToProps = state => {
    return {
      data: getData(
        state,
        'ReclaimedWellsitesSimple',
        getFeaturesFromGeoJson
      ),
      datetime: getDatetime(state, 'WellsiteRank'),
      selectedData: getSelectedData(state, 'WellsiteRankPoint'),
      uuidsSelected: state.object.uuidsSelected,
      uuidsHighlighted: state.object.uuidsHighlighted
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      centerZoomDatetimeChanged: (center, zoom, datetime) => {
        dispatch(MapActions.centerZoomChanged(center, zoom))
        dispatch(TimeSliderActions.timeSliderValueUpdated(datetime))
      },
      uuidsHighlighted: uuids => dispatch(ObjectActions.uuidsHighlighted(uuids))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  WellsiteRankContainer
)



// WEBPACK FOOTER //
// ./src/charts/WellsiteRankContainerSimple.js